import { privateClient, publicClient } from "./client";

const hireOffer = (msisdn, channel, type, keyword) => {
  privateClient.post("/customer/offer", { msisdn, channel, type, keyword });
};

function sendEvent(msisdn, eventData) {
  const url = `/customers/${msisdn}/loop/events`;
  return privateClient.post(url, eventData);
}

function sendPublicEvent(eventData) {
  const url = `/loop/public/events`;
  return publicClient.post(url, eventData);
}

export { hireOffer, sendEvent, sendPublicEvent };
